import React from "react";

const SonicBoomGuide = () => {
  return (
    <div className="kbl_sonicboom">
      <img
        className="pc"
        src={require("../../assets/img/park/sonicboom_arena@2x.png")}
        alt="sonicboom_arena"
        style={{ marginBottom: "16px" }}
      />
      <img
        className="m"
        src={require("../../assets/img/park/sonicboom_arena@2x.png")}
        alt="sonicboom_arena_m"
        style={{ marginBottom: "16px" }}
      />

      <div className="kbl_sonicboom_arena">
        <text className="kbl_sonicboom_arena_title">면적</text>
        <text className="kbl_sonicboom_arena_content">경기장면적(2,454.16m2) / 건축면적(4,997.59m2)</text>
      </div>

      <div className="kbl_sonicboom_arena">
        <text className="kbl_sonicboom_arena_title">좌석수</text>
        <text className="kbl_sonicboom_arena_content">3,614석</text>
      </div>

      <div className="kbl_sonicboom_arena">
        <text className="kbl_sonicboom_arena_title">주요시설</text>
        <text className="kbl_sonicboom_arena_content">냉난방시설 완비 / 음향설비 1식 / 영상전광판 1면</text>
      </div>

      <div className="kbl_sonicboom_arena">
        <text className="kbl_sonicboom_arena_title">무료개방</text>
        <text className="kbl_sonicboom_arena_content">무료개방 없음</text>
      </div>

      <img
        className="pc"
        src={require("../../assets/img/park/sonicboom_arena_map@3x.png")}
        alt="sonicboom_arena_map"
        style={{ marginTop: "32px" }}
      />
      <img
        className="m"
        src={require("../../assets/img/park/sonicboom_arena_map@3x.png")}
        alt="sonicboom_arena_map_m"
        style={{ marginTop: "32px" }}
      />
    </div>
  );
};

export default SonicBoomGuide;
